import { FieldStub } from "./_FieldStub";
import type { FieldPrimitiveProps } from "./types";

// STUB — CHG-1167 scaffold. Real impl lands ε CHG-1152 (recurring giving).
// Contract: specs/_product/field-primitive-registry.md §1 ('schedule_picker').
// Doctrine: feedback_field_primitive_components_canonical.md.

export function SchedulePicker(props: FieldPrimitiveProps<string>) {
  return <FieldStub {...props} fieldType="schedule_picker" inputType="text" />;
}
